import React, { useMemo } from 'react';
import {Checkbox} from 'antd';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {solid} from '@fortawesome/fontawesome-svg-core/import.macro';
import {Colors} from '../../../../../../styles/Colors';
import {GlobalConsts} from '../../../../../../styles/GlobalConsts';
import HStack from '../../../../../common/Layout/HStack';
import AppText from '../../../../../common/AppText';
import {dbTimeFormat, getPartialAttendanceDisplay} from '../../../../../../services/Helpers';
import { useSelector } from 'react-redux';
import { getBoxTimeFormat } from '../../../../../../services/Helpers';

const TrackCourseSeriesEventRow = (props) => {
    const {seriesEvent, series, onSelect, isDisabled, isChecked} = props;
    const lang = useSelector(state => state.userSettings.lang);
    const boxLocale = useMemo(() => (lang?.language === 'Hebrew' ? 'he' : 'en'), [lang]);
    const timeFormat = getBoxTimeFormat();
    const dayName = moment().weekday(seriesEvent.day_of_week).locale(boxLocale).format('dddd');
    const startTime = moment(seriesEvent.start, dbTimeFormat).format(timeFormat);
    const endTime = moment(seriesEvent.end, dbTimeFormat).format(timeFormat);
    const attendance = getPartialAttendanceDisplay(seriesEvent.id, series);
    const dayAndTime = `${dayName} ${startTime}–${endTime}`;
    const textColor = isDisabled && !isChecked ? Colors.newDesign.darkGrey : Colors.newDesign.mainText;

    return (
        <Checkbox
            checked={isChecked}
            disabled={isDisabled}
            onChange={() => onSelect(series.id, seriesEvent.id)}
            style={{marginInlineStart: 0}}
        >
            <HStack space={'0.5rem'} flex={'unset'} alignItems={'center'}>
                <AppText color={textColor}>{dayAndTime}</AppText>
                <FontAwesomeIcon icon={solid('circle-small')} fontSize={'5px'}/>
                <HStack space={'0.5rem'} flex={'unset'} alignItems={'center'}>
                    <FontAwesomeIcon icon={solid('user')} fontSize={GlobalConsts.iconSize.XXS}/>
                    <AppText color={textColor}>{attendance}</AppText>
                </HStack>
            </HStack>
        </Checkbox>
    );
};

export default TrackCourseSeriesEventRow;
